import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateAccountSettingsUpsellingsMutation = createMutationHook(
  MembershipsCreatorApiClient.updateAccountSettingsUpsellings,
  {
    mutationKey: ['updateAccountSettingsUpsellings'],
  },
)
